import { Space } from 'antd'
import { CIMSTags } from '../../../../../../../../components/CIMSTags'
import { NameDescription } from './useImplicitPermissions/types'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'

export const useCustomFieldsPanel = (
  customFields: Map<string, NameDescription[]>
): CIMSCollapsePanelOptions[] => {
  const customFieldsChildren: React.ReactNode[] = []
  customFields.forEach((fields, classType) =>
    customFieldsChildren.push(
      <>
        {`${classType}:`}
        <CIMSTags
          tags={fields.map(({ name, description }) => ({
            text: name,
            tooltip: description,
          }))}
        />
      </>
    )
  )
  return !!customFieldsChildren.length
    ? [
        {
          key: `custom-fields-${Math.random()}`,
          header: 'Custom Fields',
          children: (
            <Space direction="vertical" size="small">
              {customFieldsChildren}
            </Space>
          ),
        },
      ]
    : []
}
